import React from "react";
import { Box, Typography } from "@mui/material";
import EntityForm from "../components/EntityForm";
import { createHospital } from "../api/coreApi";
import { fkId } from "../utils/coreHelpers";

export default function HospitalFormStep({
  loading,
  setLoading,
  setErr,
  refreshAll,
  goNext,
  setSelectedHospitalId,
}) {
  const onSubmit = async (payload, helpers) => {
    setLoading(true);
    setErr("");

    try {
      const res = await createHospital(payload);
      const newId = fkId(
        res?.data?.hospital_id || res?.data?.id || res?.data?.organization_id
      );

      if (!newId) {
        setErr("Hospital created but ID not returned from API.");
        return;
      }

      // ✅ set selected hospital + move next immediately
      setSelectedHospitalId(newId);
      goNext();

      // refresh after
      await refreshAll();
      helpers?.reset?.();
    } catch (e) {
      setErr(
        e?.response?.data ? JSON.stringify(e.response.data) : "Create hospital failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 900, mb: 1 }}>Step 1: Hospital</Typography>

      <EntityForm
        title="Create Hospital"
        loading={loading}
        initialValues={{
          org_type: "HOSPITAL",
          name: "",
          registration_no: "",
          phone: "",
          address_line1: "",
          address_line2: "",
          city: "",
          state: "",
          country: "India",
          postal_code: "",
          status: "ACTIVE",
        }}
        fields={[
          {
            name: "org_type",
            label: "Org Type",
            type: "select",
            required: true,
            options: [
              { value: "HOSPITAL", label: "Hospital" },
              { value: "CLINIC", label: "Clinic" },
              { value: "LAB", label: "Lab" },
              { value: "OTHER", label: "Other" },
            ],
          },
          { name: "name", label: "Hospital Name", required: true },
          { name: "registration_no", label: "Registration No" },
          { name: "phone", label: "Phone" },

          { name: "address_line1", label: "Address line 1", required: true, fullRow: true },
          { name: "address_line2", label: "Address line 2", fullRow: true },
          { name: "city", label: "City", required: true },
          { name: "state", label: "State", required: true },
          { name: "country", label: "Country", required: true },
          { name: "postal_code", label: "Postal Code", required: true },

          {
            name: "status",
            label: "Status",
            type: "select",
            options: [
              { value: "ACTIVE", label: "Active" },
              { value: "SUSPENDED", label: "Suspended" },
            ],
          },
        ]}
        onSubmit={onSubmit}
      />
    </Box>
  );
}